import { IQuotationForEmision } from "../../services/IQuotationForEmision";

export const getEmissionRemolque = (
  quotationId: string | undefined,
  quotation: IQuotationForEmision | undefined,
  remolque: { remolque?: string } | undefined
): string | undefined => {
  const selected = quotationId
    ? quotation?.quotation_request?.remolque_cc
    : remolque?.remolque;
  return typeof selected === "string" && selected.trim() ? selected : undefined;
};
